:host {
  width: 100%;
  background-color: var(--cms-semanticColors-container-medium-background);
  display: block;
  margin-bottom: var(--cms-components-mb);
  @include cms-base-font-100;
  @include cms-margin-center;
}

:host* {
  box-sizing: border-box;
}

.store-map-container {
  @include cms-default-grid-container;
}

.store-map {
  --cms-default-grid-area: auto / auto / auto / span 12;
  grid-area: var(--cms-default-grid-area);
  visibility: visible;
  height: px-to-rem(600);
  position: relative;
  overflow: hidden;
}

.search-store {
  font-family: var(--cms-brandfont2);
  font-size: var(--cms-font-size-087);
  line-height: var(--cms-line-height-111);
  width: 18.75rem;
  padding: var(--cms-spacing-075);
}

.info-window.content-wrapper {
  padding: var(--cms-spacing-075) var(--cms-spacing-075) 0;
}

.store-details-wrapper {
  margin-bottom: var(--cms-spacing-075);
  @include cms-base-font-100;
}

.search-store-container {
  background: css-var(semanticColors-container-weak-background);
  padding: var(--cms-spacing-075);
}

.searchIconWrapper {
  position: absolute;
  top: px-to-rem(21);
  right: var(--cms-spacing-150);
  cursor: pointer;
}

.details-link {
  @include cms-anchor-base-font;
}

.details-link-wrapper {
  text-align: center;
}


@include media-width($breakpoint-sm) {
  .store-map {
    --cms-default-grid-area: auto / 2 / auto / span 10;
  }
}